// external dependencies
import { Tabulator } from "tabulator-tables";

export const FILTER_SECTION = {
  transactionTableGrid: Tabulator,
  searchFilterButton: document.querySelector<HTMLButtonElement>("#search-date-button"),
  clearFilterButton: document.querySelector<HTMLButtonElement>("#clear-filter-button"),
  startDate: document.querySelector<HTMLInputElement>("#search-date-start"),
  endDate: document.querySelector<HTMLInputElement>("#search-date-end"),
  partnerList: document.querySelector<HTMLElement>(".aafp_filter-partners-list"),
  customerList: document.querySelector<HTMLElement>("#aafp_customer-list-sort"),
  cardgroupList: document.querySelector<HTMLElement>("#aafp_cardgroup-list-sort"),
  terminalList: document.querySelector<HTMLElement>("#aafp_terminal-list-sort"),
  paymentType: document.querySelector<HTMLElement>("#aafp_payment-list-sort"),
  dateToSet: 14,
  dateToSetTwo: 2
};

export interface PaymentType {
  id: number;
  name: string;
}

export const PAYMENT_TYPE_LIST: PaymentType[] = [
  {
    id: 2,
    name: "Pay at Pump/Invoice"
  },
  {
    id: 0,
    name: "Pay at Pump"
  },
  {
    id: 1,
    name: "Invoice"
  }
];

export const MONTHS: string[] = [
  "",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];